import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.auth-card__password-toggle', async () => {
  const { initPasswordToggles } = await import('./internal/password_toggle');
  initPasswordToggles();
});

onElelementExistRunOnce('.js-password-rules', async () => {
  const { initPasswordRules } = await import('./internal/password_rules');
  initPasswordRules();
});
